__turbopack_context__.v({
  "cta": "NewsArticleCta-module-scss-module__FwA92q__cta",
  "ctaButton": "NewsArticleCta-module-scss-module__FwA92q__ctaButton",
  "ctaContent": "NewsArticleCta-module-scss-module__FwA92q__ctaContent",
  "ctaCopy": "NewsArticleCta-module-scss-module__FwA92q__ctaCopy",
  "ctaImage": "NewsArticleCta-module-scss-module__FwA92q__ctaImage",
  "ctaInner": "NewsArticleCta-module-scss-module__FwA92q__ctaInner",
  "ctaSubtitle": "NewsArticleCta-module-scss-module__FwA92q__ctaSubtitle",
  "ctaTitle": "NewsArticleCta-module-scss-module__FwA92q__ctaTitle",
});
